import {
  CALLBACK_TYPE_GET_LIST_METADATA,
  CALLBACK_TYPE_GET_HOTEL_DETAIL,
  CALLBACK_TYPE_GET_PLANS_BY_HOTEL,
  CALLBACK_TYPE_GET_ROOMS_BY_HOTEL,
  CALLBACK_TYPE_GET_CART_DETAIL,
  CALLBACK_TYPE_CREATE_ORDER,
  CALLBACK_TYPE_SEARCH_LIST_METADATA,
  CALLBACK_TYPE_GET_LIST_THEMES,
  CALLBACK_TYPE_GET_ROOM_DETAIL,
  CALLBACK_TYPE_GET_PRICE_ROOM_PLAN,
  CALLBACK_TYPE_GET_ROOM_SUGGESTION,
  CALLBACK_TYPE_GET_ROOM_NFT,
  CALLBACK_TYPE_GET_LIST_RESALE_ORDERS,
  CALLBACK_TYPE_GET_DETAIL_RESALE_ORDER,
  CALLBACK_TYPE_GET_LIST_RESALE_EXPIRED,
  CALLBACK_TYPE_GET_LIST_RESALE_ORDERS_BY_SALLER,
  CALLBACK_TYPE_LOGIN,
  CALLBACK_TYPE_CREATE_RESALE_ORDER,
  CALLBACK_TYPE_GET_USER_INFO_BY_ID,
  CALLBACK_TYPE_GET_LIST_AVAILABLE_ROOMS,
  CALLBACK_TYPE_SEARCH_METADATA_BY_ZONE,
  CALLBACK_TYPE_REGISTER,
  CALLBACK_TYPE_LOGIN_WITH_FACEBOOK,
  CALLBACK_TYPE_GET_ROOM_DETAIL_v2,
  CALLBACK_TYPE_LOGIN_WITH_GOOGLE,
  CALLBACK_TYPE_FORGOT_PASSWORD,
  CALLBACK_TYPE_RESET_PASSWORD,
  CALLBACK_TYPE_USER_CHECK_REGISTER,
  CALLBACK_TYPE_USER_TEST_STRIPE,
  CALLBACK_TYPE_USER_TEST_STRIPE_CHARGE,
  CALLBACK_TYPE_GET_CARD_TOKEN,
  GET_LIST_HOTEL_TAB,
  CALLBACK_TYPE_GET_LIST_HOTELS,
  CALLBACK_TYPE_GET_CALENDAR_PRICE_BY_HOTEL,
  CALLBACK_TYPE_GET_INFO_BY_POSTAL_CODE,
  CALLBACK_TYPE_VALIDATE_RESET_PASSWORD_CODE,
} from "../interfaces/CallbackType";
import axiosInstance from "./axios";

const getListMetadata = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_METADATA,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListHotels = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_HOTELS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getHotelDetail = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_HOTEL_DETAIL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getHotelTabs = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: GET_LIST_HOTEL_TAB,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRoomsByHotelId = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOMS_BY_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRoomsByHotelIdV2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOMS_BY_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPlansByHotelId = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_PLANS_BY_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPlansByHotelIdV2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_PLANS_BY_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getCartDetailV2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_CART_DETAIL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createOrder_v2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_CREATE_ORDER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const searchListMetadata = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_SEARCH_LIST_METADATA,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const searchListTheme = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_THEMES,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRoomDetail = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOM_DETAIL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getRoomDetailV2 = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOM_DETAIL_v2,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getPriceRoomPlan = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_PRICE_ROOM_PLAN,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListRoomsSuggest = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOM_SUGGESTION,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListRoomsNft = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOM_NFT,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListRoomsNftNew = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/nft", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_ROOM_NFT,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const resaleSearchHotelName = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_RESALE_ORDERS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListSearchResale = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_RESALE_ORDERS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getDetailResale = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_DETAIL_RESALE_ORDER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const geListResaleExpired = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_RESALE_EXPIRED,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getListResaleBySaller = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_LIST_RESALE_ORDERS_BY_SALLER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const login = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_LOGIN,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const loginWithFb = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_LOGIN_WITH_FACEBOOK,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const loginWithGG = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_LOGIN_WITH_GOOGLE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const register = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_REGISTER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createResale = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_CREATE_RESALE_ORDER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const createByResaleOrder = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_CREATE_ORDER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getUserInfoById = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      param_datas: {
        ...dataReq.param_datas,
        access_token: localStorage.getItem("access_token"),
      },
      callback_type: CALLBACK_TYPE_GET_USER_INFO_BY_ID,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getCalendarRoomBooking = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_LIST_AVAILABLE_ROOMS,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const searchMetadataByZone = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_SEARCH_METADATA_BY_ZONE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getCalendarPriceByHotel = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_CALENDAR_PRICE_BY_HOTEL,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const forgotPassword = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_FORGOT_PASSWORD,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const resetPassword = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_RESET_PASSWORD,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_check_register = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_USER_CHECK_REGISTER,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_test_stripe = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_USER_TEST_STRIPE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const user_test_stripe_charge = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_USER_TEST_STRIPE_CHARGE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const get_token_card = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_CARD_TOKEN,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const get_info_postal_code = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_GET_INFO_BY_POSTAL_CODE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const validate_reset_password_code = async (dataReq: any) => {
  try {
    const response = await axiosInstance.post("/unauth", {
      ...dataReq,
      callback_type: CALLBACK_TYPE_VALIDATE_RESET_PASSWORD_CODE,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const UnAuthServices = {
  login,
  loginWithFb,
  loginWithGG,
  register,
  getListMetadata,
  getListHotels,
  getHotelDetail,
  getRoomsByHotelId,
  getPlansByHotelId,
  searchListMetadata,
  searchListTheme,
  getRoomDetail,
  getPriceRoomPlan,
  getListRoomsSuggest,
  getListRoomsNft,
  resaleSearchHotelName,
  getListSearchResale,
  getDetailResale,
  geListResaleExpired,
  getListResaleBySaller,
  createResale,
  createByResaleOrder,
  getUserInfoById,
  getListRoomsNftNew,
  getCalendarRoomBooking,
  searchMetadataByZone,
  getCalendarPriceByHotel,
  getRoomsByHotelIdV2,
  getPlansByHotelIdV2,
  // getCalendarRoomBookingV2,
  getCartDetailV2,
  getRoomDetailV2,
  forgotPassword,
  resetPassword,
  user_check_register,
  user_test_stripe,
  user_test_stripe_charge,
  get_token_card,
  createOrder_v2,
  getHotelTabs,
  get_info_postal_code,
  validate_reset_password_code,
};

export default UnAuthServices;
